import { useEffect, useState } from "react";
import * as accountApi from "../../../api/account/api";

/** Calls the confirm-email API and tracks loading/result state. */
export const useConfirmEmail = (confirmation: string) => {
  const [checking, setChecking] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!confirmation) {
      setChecking(false);
      setConfirmed(false);
      return;
    }
    accountApi
      .confirmEmail(confirmation)
      .then((res) => {
        if (!cancelled) setConfirmed(res.isConfirmed);
      })
      .catch(() => {
        if (!cancelled) setConfirmed(false);
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [confirmation]);

  return { checking, confirmed };
};
